export default __webpack_public_path__ + "static/media/Scratchers-Fastplay-Logo.f4b9984f.svg";